import { useState } from "react";
import { deleteItem, duplicateItem, renameItem } from "@/lib/serverComm";
import { useNavigate } from "react-router-dom";

export const useItemManagement = (
  itemType: "reports" | "chats" | "dashboards" | "workspaces",
  onSuccess: () => void,
  redirectPath: string,
  type: "report" | "chat" | "dashboard" | "workspace",
) => {
  const [selectedItem, setSelectedItem] = useState<any>(null); // eslint-disable-line @typescript-eslint/no-explicit-any
  const [isRenameOpen, setIsRenameOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const navigate = useNavigate();

  const handleRename = async (newTitle: string) => {
    if (!selectedItem) return;
    try {
      await renameItem(itemType, selectedItem.id, newTitle);
      setIsRenameOpen(false);
      onSuccess();
      navigate(`${type}/${selectedItem.id}`);
    } catch (error) {
      console.error(`Failed to rename ${itemType}:`, error);
    }
  };

  const handleDelete = async () => {
    if (!selectedItem) return;
    try {
      await deleteItem(itemType, selectedItem.id);
      setIsDeleteOpen(false);
      onSuccess();
      navigate(redirectPath);
    } catch (error) {
      console.error(`Failed to delete ${itemType}:`, error);
    }
  };

  const handleDuplicate = async (item: { id: string }) => {
    if (!item) return;
    const duplicatedItem = await duplicateItem(itemType, item.id);
    onSuccess();
    navigate(`${type}/${duplicatedItem.id}`);
  };

  return {
    selectedItem,
    setSelectedItem,
    isRenameOpen,
    setIsRenameOpen,
    isDeleteOpen,
    setIsDeleteOpen,
    handleRename,
    handleDelete,
    handleDuplicate,
  };
};
